<template>
  <!--<div id="videoPlayer-container" style="z-index:10; display:none" class="background top-left animated fadeIn"-->
  <div id="videoPlayer-container" style="z-index:10; display:none" class="background top-left"
       @mouseout="handleMouseOut" @mousemove="handleMouseMove">
    <div id="bg-mask-popup-video-player" v-show="customControl"></div>
    <!-- Remove controls if we need to use custom video control -->
    <video id="popup-video-player" class="video_player background" width="100%"
           controls controlsList="nodownload nofullscreen"
           style="z-index:10" playsinline @click="handlePlayPause">
      <source id="popup-video-player-src" type="video/mp4">
    </video>
    <div id="close-video-btn" class="c-button bk-menu-icon" style="z-index:20" @click="close()"></div>
    <!--<div id="close-video-btn" class="background close-video-btn" style="z-index:10" @click="close()"></div>-->

    <video-controls v-show="customControl" ref="controls" :videoId="'popup-video-player'"
          @hide-vid-controls="handleHideControl"  @show-vid-controls="handleShowControl"></video-controls>
  </div>
</template>

<script>
  import { TweenMax } from 'gsap';
  import VideoControls from './video-controls/Video-Controls';

  export default {
    components: { VideoControls },
    name: 'video-player',
    // customControl - true will enable videoControl
    // - false - use native html5 video control
    props: ['source', 'customControl'],
    computed: {
    },
    created() {
      this.hideCloseButton = false;
      this.videoPlayer = null;
      this.videoPlayerSrc = null;
    },
    mounted() {
      this.hide();
      const that = this;
      this.videoPlayer = document.getElementById('popup-video-player');
      this.videoPlayerSrc = document.getElementById('popup-video-player-src');
      this.videoPlayer.addEventListener('playing', this.videoStartedEventHandler, false);
      this.videoPlayer.addEventListener('ended', this.onVideoEnded, false);
      // this.videoPlayer.setAttribute('type', 'video/mp4');
      this.closeButton = document.getElementById('close-video-btn');
      if (this.hideCloseButton) {
        that.hideBackButtonTimer = that.hideBackButton();
      }
    },
    methods: {
      isPlaying() {
        const video = this.videoPlayer;
        return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
      },
      handlePlayPause() {
        if (this.isPlaying() && !this.customControl) {
          this.videoPlayer.pause();
        } else {
          this.videoPlayer.play();
        }
      },
      handleMouseMove() {
        const that = this;
        // $('#close-video-btn').show();
        TweenMax.to(this.closeButton, 0.25, { autoAlpha:1 });
        this.videoPlayer.controls = !this.customControl;
        if (that.hideBackButtonTimer) {
          clearTimeout(that.hideBackButtonTimer);
        }
        that.hideBackButtonTimer = that.hideBackButton();
      },
      handleMouseOut() {
        if (this.hideCloseButton) {
          TweenMax.to(this.closeButton, 0.25, {autoAlpha: 0});
          // this.$refs['controls']. hideControls();
        }
      },
      handleHideControl() {
        // console.log('Video Player - hide controls.');
      },
      handleShowControl() {
        // console.log('Video Player - show controls.');
        // this.$refs['controls']. showControls();
      },
      hideBackButton() {
        return setTimeout(() => {
          // $('#close-video-btn').hide();
          if (this.hideCloseButton) {
            TweenMax.to(this.closeButton, 0.25, {autoAlpha: 0});
            this.videoPlayer.controls = false;
          }
        }, 2500);
      },
      exitFullScreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      },
      play(source) {
        this.videoPlayerSrc.setAttribute('src', source);
        this.videoPlayer.controls = false;
        this.videoPlayer.load();
        this.videoPlayer.play();


        // $('#close-video-btn').hide();
        if (this.hideCloseButton) {
          TweenMax.to(this.closeButton, 0.25, {autoAlpha: 0});
        }
      },
      close() {
        this.videoPlayer.pause();
        this.hide();
      },
      videoStartedEventHandler() {
        this.show();
      },
      onVideoEnded() {
        this.exitFullScreen();
        this.hide();
      },
      show() {
        document.getElementById('videoPlayer-container').style.display = 'block';
        document.getElementById('close-video-btn').style.display = 'block';
        document.getElementById('popup-video-player').style.display = 'block';
        document.getElementById('bg-mask-popup-video-player').style.display = 'block';
      },
      hide() {
        document.getElementById('videoPlayer-container').style.display = 'none';
        document.getElementById('close-video-btn').style.display = 'none';
        document.getElementById('popup-video-player').style.display = 'none';
        document.getElementById('bg-mask-popup-video-player').style.display = 'none';
      },
    },
    data() {
      return {
        videoPlayer: null,
        videoPlayerSrc: null,
        hideBackButtonTimer: null,
        closeButton: undefined,
      };
    },
  };
</script>

<style lang="css" rel="stylesheet/css" scoped>
  #videoPlayer-container {
    -webkit-animation-delay: .25s;
    -moz-animation-delay: .25s;
    animation-delay: .25s;
    -webkit-animation-duration: .5s;
    -moz-animation-duration: .5s;
    animation-duration: .5s;
  }

  #bg-mask-popup-video-player {
    width: 100%;
    height: 100%;
    position: absolute;
    /* background-color: rgba(0,0,0,1); */
    background-color: black;
    z-index: 3;
    display: none;
  }

  .video_player {
    cursor: initial;
  }

  video::-webkit-media-controls-fullscreen-button{
    display: none;
  }
</style>




// WEBPACK FOOTER //
// Video-Player.vue?9a43369c